import { render, staticRenderFns } from "./xjsrdzd.vue?vue&type=template&id=c7da0a90&scoped=true&"
import script from "./xjsrdzd.vue?vue&type=script&lang=js&"
export * from "./xjsrdzd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7da0a90",
  null
  
)

export default component.exports